import { render, staticRenderFns } from "./problemAndLookupData.vue?vue&type=template&id=dec9649e&scoped=true&"
import script from "./problemAndLookupData.vue?vue&type=script&lang=js&"
export * from "./problemAndLookupData.vue?vue&type=script&lang=js&"
import style0 from "./problemAndLookupData.vue?vue&type=style&index=0&id=dec9649e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec9649e",
  null
  
)

export default component.exports